"use client";

import { useEffect, useState } from "react";
import { isLocalBypassAuthEnabled } from "@/lib/local-bypass-auth";
import { phGetFeatureFlag, phOnFeatureFlags } from "@/lib/posthog/client/runtime";

export function useFeatureFlag(key: string): boolean {
  const bypass = isLocalBypassAuthEnabled();
  const [on, setOn] = useState(false);
  useEffect(() => {
    if (bypass) return;
    const check = () => setOn(Boolean(phGetFeatureFlag(key, { send_event: false })));
    const unsubscribe = phOnFeatureFlags(check);
    check();
    return unsubscribe;
  }, [bypass, key]);
  return bypass || on;
}
